export const decodeUrlFilterValue = (value: string): string => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

export const normalizeUrlFilterValue = (
  value: string,
  allowedValues?: unknown[],
): string => {
  if (allowedValues?.includes(value)) return value;

  const decodedValue = decodeUrlFilterValue(value);

  return allowedValues?.includes(decodedValue) ? decodedValue : value;
};

export const serializeUrlFilterValue = (data: string | string[]): string => (
  Array.isArray(data)
    ? [...data]
      .sort((a, b) => Number(a) - Number(b))
      .map(decodeUrlFilterValue)
      .join(';')
    : decodeUrlFilterValue(data)
);
